import React, { useMemo } from 'react';
import './App.css';

/**
 * Detects the current auth mode from URL parameters.
 * IAP/gcip-iap uses 'mode' parameter with lowercase values: 'signin' or 'signout'
 */
function getAuthMode(): 'signIn' | 'signOut' {
  const urlParams = new URLSearchParams(window.location.search);
  const mode = urlParams.get('mode')?.toLowerCase();

  if (mode === 'signout') {
    return 'signOut';
  }

  return 'signIn';
}

/**
 * Main App component for the Identity Broker Auth UI.
 *
 * This component displays a loading state while the gcip-iap
 * Authentication handles the actual auth flow. It detects
 * whether we're signing in or signing out and displays
 * appropriate messaging.
 */
export const App: React.FC = () => {
  const authMode = useMemo(() => getAuthMode(), []);
  const isSignOut = authMode === 'signOut';

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="logo">
          <img
            src="https://static.bombora.com/img/logos/bombora_logo-Orange-2025.png"
            alt="Bombora"
          />
        </div>

        <div className="auth-content">
          <h1>{isSignOut ? 'Signing Out' : 'Signing In'}</h1>
          <p>
            {isSignOut
              ? 'Please wait while we securely sign you out.'
              : 'Please wait while we securely authenticate you.'}
          </p>

          <div id="loading-indicator" className="loading">
            <div className="spinner"></div>
          </div>
        </div>

        <div className="auth-footer">
          <p>
            Having trouble?{' '}
            <a href="https://bombora.com/customer-support-forms/" target="_blank" rel="noopener noreferrer">Contact Support</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default App;
